<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="row m-2">
            <div>
              <div>
                <b-row>
                  <b-col
                    sm="12"
                    lg="1"
                    md="4"
                    class="
                      d-flex
                      align-items-center
                      justify-content-start
                      mb-1 mb-md-0
                    "
                  >
                    <multiselect
                      style="width: 100px"
                      :show-labels="false"
                      :placeholder="$t('')"
                      v-model="filter.PageLimit"
                      :options="filter.perPageOptions"
                      @input="Refresh"
                      class="per-page-selector d-inline-block ml-50"
                    ></multiselect>
                  </b-col>
                  <b-col sm="12" lg="3">
                    <b-input-group>
                      <b-form-input
                        :placeholder="$t('search')"
                        v-model="filter.Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button @click="Refresh" variant="primary">
                          <i class="fas fa-search"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col>
                    <b-button
                      v-if="$can('PurReqPlacementEdit', 'permissions')"
                      variant="primary"
                      :to="{
                        name: 'EditPurReqPlacement',
                        params: { id: 0 },
                      }"
                    >
                      <i class="bx bx-plus"></i>
                      {{ $t("create") }}
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <div>
                <!-- <b-button variant="primary"> <i class="mdi mdi-plus"></i> {{ $t('create') }} </b-button> -->
              </div>
            </div>
          </div>
          <div class="row m-2">
            <div class="col">
              <b-table
                :fields="fields"
                bordered
                :items="items"
                responsive="sm"
                style="min-height:300px"
                show-empty
                :busy="isLoading"
                head-row-variant="info"
                sticky-header="60vh"
                no-border-collapse
                small
              >
                <template #cell(totalpurchasesum)="{item}">
                  {{
                    $options.filters.currency(item.totalpurchasesum, {
                      symbol: " ",
                      fractionCount: 2,
                    })
                  }}
                </template>
                <template #cell(actions)="{item}">
                  <div>
                    <b-link
                      v-if="
                        $can('PurReqPlacementEdit', 'permissions') &&
                          item.statusname !== 'Оценен' &&
                          item.statusname !== 'Одобрен' &&
                          item.statusname !== 'Отправлен' &&
                          item.statusname !== 'Отменено' &&
                          item.statusname !== 'Утвержден'
                      "
                      :to="{
                        name: 'EditPurReqPlacement',
                        params: { id: item.id },
                      }"
                      v-b-tooltip.hover.top="$t('Edit')"
                      style="margin-right: 5px"
                    >
                      <i class="bx bx-pencil"></i>
                    </b-link>
                    <!-- <b-link
                      v-if="$can('PurReqPlacementView', 'permissions')"
                      :to="{
                        name: 'ViewPurReqPlacement',
                        params: { id: item.id },
                      }"
                      v-b-tooltip.hover.top="$t('View')"
                      style="margin-right: 5px"
                    >
                      <i class="mdi mdi-eye"></i>
                    </b-link> -->
                    <b-link
                      v-if="
                        $can('PurReqPlacementApprove', 'permissions') &&
                          item.statusname !== 'Оценен' &&
                          item.statusname !== 'Одобрен' &&
                          item.statusname !== 'Отправлен' &&
                          item.statusname !== 'Отменено' &&
                          item.statusname !== 'Утвержден'
                      "
                      @click="$refs['ApproveModal' + item.id].show()"
                      v-b-tooltip.hover.top="$t('Approve')"
                    >
                      <i class="bx bx-check"></i>
                    </b-link>
                    <b-link
                      v-if="
                        $can('PurReqPlacementCancelApproval', 'permissions') &&
                          item.statusname !== 'Создан' &&
                          item.statusname !== 'Изменен' &&
                          item.statusname !== 'Отправлен' &&
                          item.statusname !== 'Отменено'
                      "
                      @click="$refs['CancelApproveModal' + item.id].show()"
                      v-b-tooltip.hover.top="$t('CancelApprove')"
                    >
                      <i class="bx bx-x"></i>
                    </b-link>

                    <b-link
                      v-if="
                        $can('PurReqPlacementDelete', 'permissions') &&
                          item.statusname !== 'Оценен' &&
                          item.statusname !== 'Одобрен' &&
                          item.statusname !== 'Отправлен' &&
                          item.statusname !== 'Отменено' &&
                          item.statusname !== 'Утвержден'
                      "
                      @click="$refs['DeleteModal' + item.id].show()"
                      v-b-tooltip.hover.top="$t('Delete')"
                    >
                      <i class="bx bx-trash-alt"></i>
                    </b-link>
                  </div>
                  <b-modal
                    :ref="'DeleteModal' + item.id"
                    :title="$t('Delete')"
                    :cancel-title="$t('Cancel')"
                    :ok-title="$t('Accept')"
                    cancel-variant="danger"
                    ok-variant="success"
                    @ok="Delete(item)"
                  >
                    <b-card-text>
                      <h5>ID : {{ item.id }}</h5>
                      <h5>{{ $t("WantDelete") }}</h5>
                    </b-card-text>
                  </b-modal>
                  <b-modal
                    :ref="'CancelApproveModal' + item.id"
                    :title="$t('CancelApproval')"
                    :cancel-title="$t('Cancel')"
                    :ok-title="$t('Accept')"
                    cancel-variant="danger"
                    ok-variant="success"
                    @ok="CancelApproval(item)"
                  >
                    <b-card-text>
                      <h5>ID : {{ item.id }}</h5>
                      <h5>{{ $t("WantDelete") }}</h5>
                    </b-card-text>
                  </b-modal>
                  <b-modal
                    :ref="'ApproveModal' + item.id"
                    :title="$t('Approve')"
                    :cancel-title="$t('Cancel')"
                    :ok-title="$t('Accept')"
                    cancel-variant="danger"
                    ok-variant="success"
                    @ok="Approve(item)"
                  >
                    <b-card-text>
                      <h5>ID : {{ item.id }}</h5>
                      <h5>{{ $t("WantApprove") }}</h5>
                    </b-card-text>
                  </b-modal>
                </template>
                <template v-slot:empty>
                  <h5 class="text-center">{{ $t("NoItems") }}</h5>
                </template>
                <template v-slot:table-busy>
                  <div
                    class="text-center text-primary my-2"
                    style="vertical-align: middle"
                  >
                    <b-spinner
                      style="margin-right: 10px"
                      class="align-middle"
                    ></b-spinner>
                    <strong>{{ $t("Loading") }}</strong>
                  </div>
                </template>
                <template #cell(statusname)="{ item }">
                  <span
                    :class="
                      `badge rounded-pill bg-${$getItemColorStatus(item)} ms-1`
                    "
                  >
                    {{ item.statusname }}
                  </span>
                </template>
              </b-table>
            </div>
          </div>
          <div>
            <b-row class="m-2">
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
              >
                <span class="text-muted">
                  {{ $t("Showing") }} {{ firstNumber }} {{ $t("to") }}
                  {{ lastNumber }} {{ $t("of") }} {{ filter.totalRows }}
                  {{ $t("entries") }}
                </span>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
              >
                <b-pagination
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @input="Refresh"
                  :per-page="filter.PageLimit"
                  :total-rows="filter.totalRows"
                  v-model="filter.PageNumber"
                >
                  <template #prev-text>
                    <i class="fas fa-angle-left"></i>
                  </template>
                  <template #next-text>
                    <i class="fas fa-angle-right"></i>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import HelperService from "@/services/others/helper.service";
import PurReqPlacementService from "@/services/document/purreqplacement.service";
export default {
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: this.$t("PurReqPlacement"),
      braedcrumb: [
        {
          text: this.$t("Document"),
        },
        {
          text: this.$t("PurReqPlacement"),
          active: true,
        },
      ],
      isLoading: false,
      filter: {
        Search: "",
        SortColumn: "",
        OrderType: "dsc",
        PageNumber: 1,
        PageLimit: 20,
        FinYear: 0,
        perPageOptions: [10, 20, 50, 100],
        totalRows: 0,
        SortIcon: "bx bxs-down-arrow",
      },
      fields: [
        {
          key: "id",
          label: this.$t("id"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "docnumber",
          label: this.$t("№"),
          tdClass: "text-right",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "organizationname",
          label: this.$t("organization"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "productcategoryname",
          label: this.$t("productcategory"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        // {
        //   key: "departmentname",
        //   label: this.$t("department"),
        //   sortable: true,
        // },
        // {
        //   key: "personname",
        //   label: this.$t("person"),
        //   sortable: true,
        // },
        {
          key: "tradetypename",
          label: this.$t("tradetype"),
          tdClass: "text-left",
          sortable: true,
          thStyle: { width: "10% !important" },
        },
        {
          key: "detailinfo",
          label: this.$t("detailinfo"),
          sortable: true,
        },
        {
          key: "statusname",
          label: this.$t("status"),
          sortable: true,
          thStyle: { width: "5% !important" },
        },
        {
          key: "actions",
          label: this.$t("actions"),
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
          thStyle: { width: "5% !important" },
        },
      ],
      items: [],
      FinYearList: [],
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    },
  },
  created() {
    // HelperService.GetAllFinYear().then((res) => {
    //   this.FinYearList = res.data;
    // });

    this.Refresh();
  },
  methods: {
    ChangeSort(columnName) {
      this.filter.SortColumn = columnName;
      if (this.filter.OrderType == "asc") {
        this.filter.SortIcon = "arrow-down";
        this.filter.OrderType = "desc";
      } else {
        this.filter.SortIcon = "arrow-up";
        this.filter.OrderType = "asc";
      }
      this.Refresh();
    },
    Approve(item) {
      this.ApproveLoading = true;
      PurReqPlacementService.Approve(item.id)
        .then((res) => {
          this.ApproveLoading = false;
          this.Refresh();
          this.$notification(this.$t("ApproveSuccess"), "success");
        })
        .catch((error) => {
          this.ApproveLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    CancelApproval(item) {
      this.CancelApprovalLoading = true;
      PurReqPlacementService.CancelApproval(item.id)
        .then((res) => {
          this.CancelLoading = false;
          this.Refresh();
          this.$notification(this.$t("CancelApprovalSuccess"), "success");
        })
        .catch((error) => {
          this.CancelLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
    Delete(item) {
      this.DeleteLoading = true;
      PurReqPlacementService.Delete(item.id)
        .then((res) => {
          this.DeleteLoading = false;
          this.Refresh();
          this.$notification(this.$t("DeleteSuccess"), "success");
        })
        .catch((error) => {
          this.$notification(error.response.data.error, "danger");
          this.DeleteLoading = false;
        });
    },
    SortChange(data) {
      this.filter.SortColumn = data.sortBy;
      this.filter.OrderType = data.sortDesc ? "desc" : "asc";
      this.Refresh();
    },
    getItemColorStatus(item) {
      if (item.statusname === "Создан") {
        return "primary";
      } else if (item.statusname === "Изменен") {
        return "info";
      } else if (item.statusname === "Отклонен") {
        return "danger";
      } else if (item.statusname === "Отменено") {
        return "danger";
      } else if (item.statusname === "Утвержден") {
        return "success";
      } else if (item.statusname === "Оценен") {
        return "secondary";
      } else if (item.statusname === "Одобрен") {
        return "success";
      } else if (item.statusname === "Отправлен") {
        return "warning";
      } else {
        return "primary";
      }
    },
    Refresh() {
      this.isLoading = true;
      PurReqPlacementService.GetList(
        this.filter.Search,
        this.filter.SortColumn,
        this.filter.OrderType,
        this.filter.PageNumber,
        this.filter.PageLimit,
        this.filter.FinYear
      )
        .then((res) => {
          this.items = res.data.rows;
          this.filter.totalRows = res.data.total;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$notification(error.response.data.error, "danger");
        });
    },
  },
};
</script>

<style>
.text-right {
  text-align: right;
}
</style>
